<template>
	<div class="wrap">
		<myHead></myHead>
		<div class="wrap_body">
			<div class="center">
				<div class="ucenter_main">
					<ucMenu num="5"></ucMenu>
					<div class="right_con">
						<div class="shangjia_main">
							<p class="fb">上架策略</p>
							<div class="opts_wrap">
								<div class="opts_line">
									<p class="txt">价格公式：</p>
									<div class="con">
										<p class="t">原价格 x</p>
										<el-input class="w80 ml8" v-model="coefficient"></el-input>%
										<el-select class="w80 ml8" v-model="type">
											<el-option label="+" :value="1">+</el-option>
											<el-option label="-" :value="2">-</el-option>
										</el-select>
										<el-input class="w80 ml8" v-model="money"></el-input>
										<p class="t ml8">元</p>
									</div>
								</div>
								<div class="opts_line">
									<p class="txt txt_check"><el-checkbox v-model="open_coefficient_2"></el-checkbox>升级款价格公式：</p>
									<div class="con">
										<p class="t">原价格 x</p>
										<el-input class="w80 ml8" v-model="coefficient_2"></el-input>%
										<el-select class="w80 ml8" v-model="type_2">
											<el-option label="+" :value="1">+</el-option>
											<el-option label="-" :value="2">-</el-option>
										</el-select>
										<el-input class="w80 ml8" v-model="money_2"></el-input>
										<p class="t ml8">元</p>
									</div>
								</div>
								<div class="opts_line">
									<p class="txt txt_check"><el-checkbox v-model="open_coefficient_3"></el-checkbox>旗舰款价格公式：</p>
									<div class="con">
										<p class="t">原价格 x</p>
										<el-input class="w80 ml8" v-model="coefficient_3"></el-input>%
										<el-select class="w80 ml8" v-model="type_3">
											<el-option label="+" :value="1">+</el-option>
											<el-option label="-" :value="2">-</el-option>
										</el-select>
										<el-input class="w80 ml8" v-model="money_3"></el-input>
										<p class="t ml8">元</p>
									</div>
								</div>
								<!--<div class="opts_line">
									<p class="txt">分角设置：</p>
									<div class="con">
										<el-radio-group v-model="radio_type">
											<el-radio :label="item.type" v-for="(item,index) in fenjiao" :key="index">{{item.name}}</el-radio>
										</el-radio-group>
									</div>
								</div>-->
								<div class="opts_line">
									<p class="txt">每个用户每次下单限购件数：</p>
									<div class="con">
										<el-input-number v-model="maximum_per_order" placeholder="请输入每个用户每次下单限购件数"></el-input-number>
									</div>
								</div>
								<div class="opts_line">
									<p class="txt">每个用户累计限购件数：</p>
									<div class="con">
										<el-input-number v-model="limit_per_buyer" placeholder="请输入每个用户累计限购件数"></el-input-number>
									</div>
								</div>
								<div class="opts_line">
									<p class="txt">每个用户每次下单至少购买的件数：</p>
									<div class="con">
										<el-input-number v-model="minimum_per_order" placeholder="请输入每个用户每次下单至少购买的件数"></el-input-number>
									</div>
								</div>
								<div class="opts_line" style="display: none;">
									<p class="txt">一口价设置：</p>
									<div class="con">
										<el-radio-group v-model="radio_price">
											<el-radio :label="item.type" v-for="(item,index) in price" :key="index">{{item.name}}</el-radio>
										</el-radio-group>
									</div>
								</div>
								
								<div class="opts_line">
									<p class="txt">库存类型：</p>
									<div class="con">
										<el-radio-group v-model="stock_type">
											<el-radio :label="10">同步上家库存</el-radio>
											<el-radio :label="20">默认库存N件</el-radio>
										</el-radio-group>
									</div>
								</div>
								<div class="opts_line" v-if="stock_type==20">
									<p class="txt">默认库存数量：</p>
									<div class="con">
										<el-input style="width: 250px;" v-model="default_stock" placeholder="请输入默认库存数量"/>
									</div>
								</div>
								
								<div class="opts_line">
									<p class="txt">上架方式：</p>
									<div class="con" v-if="puhuo_type">
										<el-radio-group v-model="puhuo_type">
											<el-radio :label="1">上架售卖</el-radio>
											<el-radio :label="2">放入仓库</el-radio>
											<el-radio :label="3">放入草稿箱</el-radio>
										</el-radio-group>
									</div>
								</div>
								<div class="opts_line">
									<p class="txt">发货时间：</p>
									<div class="con">
										<el-select class="ml8" v-model="deliver_id" placeholder="请选择发货时间">
											<el-option :key="item.id" :label="item.label" :value="item.id"
												v-for="(item,index) in deliver"></el-option>
										</el-select>
									</div>
								</div>
								<!-- <div class="opts_line">
									<p class="txt">抖店运费模板：</p>
									<div class="con">
										<div class="shop_list">
											<div class="shop_item" v-for="(item,index) in dd_shop_list" :key="index">
												<span class="shop_name">{{item.shop_name}}</span>
												<el-select class="ml8" v-model="dd_shop_list[index].freight_template_id">
													<el-option :label="t.template_name" :value="t.freight_id"
														v-for="(t,tidx) in item.freight_template">{{t.template_name}}</el-option>
												</el-select>
											</div>
										</div>
									</div>
								</div> -->
								<div class="btn_wrap">
									<p class="btn" @click="saveBtn()">保存</p>
									<p class="btn" @click="reset()">重置</p>
								</div>
							</div>
						</div>
						<div class="link_shangjia">
							<div class="tips_box flex items-center">
								<div class="left">
									重要提示
									<img :src="tipsPic" class="tips_pic">
								</div>
								<div class="right">
									<p class="line">通过1688链接向店铺铺货时，请仔细自查商品图片、标题等是否含敏感违规词，同时确认库存状态、商品价格(商品铺货后价格是否符合预期)、48小时内发货时效及抖音电子面单支持情况。</p>
									<p class="line red">仅为您更新库存与价格，其余信息需您自行关注。若因上述任何问题引发违规，相关后果需由您自行承担。</p>
								</div>

							</div>
							<div class="link_main">
								<p class="title">链接铺货</p>
								<div class="step_box">
									<div class="step_left">
										<p class="step"><span class="num">1</span>在下方选框内粘贴1688商品链接</p>
										<p class="step"><span class="num">2</span>注意:不支持一件代发的商品链接无法加入铺货列表</p>
									</div>
									<div class="step_right">
										<el-button type="primary" size="small" @click="confirmSend()">提交铺货</el-button>
									</div>
								</div>

								<div class="input_box">
									<el-input
										type="textarea"
										:autosize="{ minRows: 4, maxRows: 1000}"
										:clearable="true"
										placeholder="请输入1688链接，链接间以回车换行显示"
										v-model="sendData.links">
									</el-input>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<shopList ref="child"></shopList>
		<myFoot></myFoot>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		mapActions,
		mapState,
		mapMutations
	} from "vuex";
	import tipsPic from '../../assets/images/tips.png';
	import myHead from '../../components/myHead/myhead';
	import myFoot from '../../components/myFoot/myfoot';
	import ucMenu from '../../components/ucenterMenu/ucmenu';
	import shopList from '../../components/shopList/shopList';

	export default {
		name: "ucenterShangjiacelve",
		data() {
			return {
				coefficient: "1.00",
				money: "0.00",
				type: 1,
				open_coefficient_2: false,
				coefficient_2: "1.00",
				money_2: "0.00",
				type_2: 1,
				open_coefficient_3: false,
				coefficient_3: "1.00",
				money_3: "0.00",
				type_3: 1,
				maximum_per_order: 3,
				limit_per_buyer: 5,
				minimum_per_order: 1,
				fenjiao: [],
				price: [],
				deliver: [],
				radio_type: 1,
				radio_price: 1,
				puhuo_type: 0,
				deliver_id: '',
				is_save: false,
				cl_id: "",
				dd_shop_list: [],
				sendData:{
					links:''
				},
				stock_type: 10,
				default_stock: 0
			}
		},
		components: {
			myHead,
			myFoot,
			ucMenu,shopList
		},
		computed: {
			...mapState({

			}),
			tipsPic() {
				return tipsPic
			}
		},
		created() {
			this.getCelveData({
				data: {},
				success: (res) => {
					if (res.code === 200) {
						console.log('get celve', res)
						let strategy = res.data.data

						let s_fenjiao = strategy.fenjiao
						let s_price = strategy.set_price
						// this.dd_shop_list = strategy.dd_shop_list
						this.deliver = strategy.deliver
						this.deliver_id = strategy.deliver_id
						this.coefficient = strategy.coefficient
						this.money = strategy.money
						this.type = strategy.type
						this.open_coefficient_2 = strategy.open_coefficient_2 == 1
						this.coefficient_2 = strategy.coefficient_2 == 0 ? 110 : strategy.coefficient_2
						this.money_2 = strategy.money_2
						this.type_2 = strategy.type_2
						this.open_coefficient_3 = strategy.open_coefficient_3 == 1
						this.coefficient_3 = strategy.coefficient_3 ? 120 : strategy.coefficient_3
						this.money_3 = strategy.money_3
						this.type_3 = strategy.type_3
						this.maximum_per_order = strategy.maximum_per_order
						this.limit_per_buyer = strategy.limit_per_buyer
						this.minimum_per_order = strategy.minimum_per_order
						this.fenjiao = s_fenjiao
						this.radio_type = strategy.set_fenjiao
						this.price = s_price
						this.cl_id = strategy.id
						this.puhuo_type = strategy.puhuo_type?strategy.puhuo_type:1
						this.stock_type = strategy.stock_type || 10
						this.default_stock = strategy.stock_type==10?0:strategy.default_stock
						for (let i in s_fenjiao) {
							if (s_fenjiao[i].xuanze) {
								this.radio_type = s_fenjiao[i].type
								break
							}
						}
						for (let i in s_price) {
							if (s_price[i].xuanze) {
								this.radio_price = s_price[i].type
								break
							}
						}
					} else {
						this.$message({
							message: res.msg,
							type: 'error',
						});
					}
				}
			})
		},
		methods: {
			...mapActions({
				getCelveData: "ucenter/getCelveData",
				saveCelveData: "ucenter/saveCelveData",
				sendAddAlibabaUrl: "ucenter/sendAddAlibabaUrl"
			}),
			saveBtn() {
				if (!this.is_save) {
					// let shop_freight_id = []
					// for(var i in this.dd_shop_list){
					// 		var item = this.dd_shop_list[i]
					// 		shop_freight_id.push({shop_id:item.shop_id,freight_template_id:item.freight_template_id})
					// }
					let params = {
						id: this.cl_id,
						coefficient: this.coefficient,
						type: this.type,
						money: this.money,
						open_coefficient_2: this.open_coefficient_2 ? 1 : 0,
						coefficient_2: this.coefficient_2,
						money_2: this.money_2,
						type_2: this.type_2,
						open_coefficient_3: this.open_coefficient_3 ? 1 : 0,
						coefficient_3: this.coefficient_3,
						money_3: this.money_3,
						type_3: this.type_3,
						maximum_per_order: this.maximum_per_order,
						limit_per_buyer: this.limit_per_buyer,
						minimum_per_order: this.minimum_per_order,
						deliver_id: this.deliver_id,
						set_fenjiao: this.radio_type,
						set_price: this.radio_price,
						puhuo_type: this.puhuo_type,
						stock_type: this.stock_type,
						default_stock: this.default_stock
						// shop_freight_id: shop_freight_id
					}
					console.log('save celve', params)
					this.is_save = true
					this.saveCelveData({
						data: params,
						success: (res) => {
							this.is_save = false
							if (res.code === 200) {
								// console.log('save celve',res)
								this.$message({
									message: res.msg,
									type: 'success',
								});
							} else {
								this.$message({
									message: res.msg,
									type: 'error',
								});
							}
						}
					})
				}
				// console.log('11',this.coefficient,this.money,this.type,this.radio_type,this.radio_price)
			},
			confirmSend(){//打开子组件店铺列表
				this.$refs.child.showShopList()
			},
			reset() {
				this.coefficient = "1.00"
				this.money = "0.00"
				this.type = 1
				this.radio_type = 1
				this.radio_price = 1
			},
			phSubmit(val,freight_template_ids){//立即铺货
				let param = {shop_id:val,freight_template_ids:freight_template_ids,links:this.sendData.links}
				console.log('phSubmit',param)
				this.sendAddAlibabaUrl({data:param,success:(res)=>{
						if(res.code===200){
							this.$message({message: res.msg,type: 'success',});
							setTimeout(()=>{
								this.$refs.child.closeShopList()
							},300)
						} else {
							this.$message({message: res.msg,type: 'error',});
						}
					}})
			}
		},
	}
</script>

<style lang="less" scoped>
	.wrap .wrap_body {
		display: flex;
		flex-direction: column;
	}

	.center {
		display: flex;
		flex: 1;
	}

	.ucenter_main {
		padding: 30px 0 40px;
		display: flex;
		justify-content: space-between;
		flex: 1;
	}

	.right_con {
		width: 980px;
	}

	.shangjia_main {
		padding: 36px 40px;
		background: #fff;
	}

	.opts_wrap {
		margin-left: 50px;
		padding-top: 14px;
	}

	.opts_wrap .opts_line {
		margin-top: 30px;
		display: flex;
		align-items: center;
	}

	.opts_line .txt {
		width: 140px;
		text-align: right;
		font-size: 14px;
	}
	.opts_line .txt.txt_check {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.opts_line .con {
		flex: 1;
		width: 0;
		margin-left: 22px;
		display: flex;
		align-items: center;
	}

	.opts_line .con .t {
		font-size: 14px;
	}

	.opts_wrap .btn_wrap {
		margin: 40px 0 0 112px;
		display: flex;
	}

	.opts_wrap .btn_wrap .btn {
		width: 80px;
		height: 34px;
		border-radius: 4px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-right: 14px;
		cursor: pointer;
		box-sizing: border-box;
		font-size: 14px;
	}

	.opts_wrap .btn_wrap .btn:nth-child(1) {
		background: var(--red);
		color: #fff;
	}

	.opts_wrap .btn_wrap .btn:nth-child(2) {
		background: #fff;
		color: #333;
		border: 1px solid #ddd;
	}

	.ml8 {
		margin-left: 8px;
	}

	.w80 {
		width: 80px;
	}

	.shop_list {
		width: auto;
	}

	.shop_list .shop_item {
		border-bottom: 1px solid #ededed;
		padding: 0 10px;
	}


	.link_shangjia{
		padding: 36px 40px;background: #fff;
		margin-top: 20px;
		.tips_box{
			border: 1px solid #f0413e;
			background: rgba(249, 243, 234, .35);
			padding: 10px;
			border-radius: 6px;
			display: flex;
			align-items: center;
			.left {
				display: flex;
				align-items: center;
				white-space: nowrap;
				font-size: 14px;
				margin-right: 10px;
				background: var(--red);
				color: #fff;
				padding: 2px 5px;
				border-radius: 4px;
				.tips_pic {
					display: inline-block;
					width: 20px;
					height: 20px;
					position: relative;
					top: -3px;
					right: -3px;
				}
			}
			.right{flex: 1;}
			.line{
				font-size: 14px;
				font-weight: 600;
			}
		}
		.link_main{
			padding: 20px 0;
			.title{
				font-size: 16px;font-weight: 600;
			}
			.step_box{
				display: flex;
				justify-content: space-between;
				.step{
					font-size: 14px;
					display: flex;
					align-items: center;
					margin-top: 10px;
					.num {
						background: #cde9f5;
						color: #00BCD4;
						width: 16px;
						height: 16px;
						border-radius: 50%;
						font-size: 12px;
						display: flex;
						align-items: center;
						justify-content: center;
						margin-right: 10px;

					}
				}
				.step_right{
					display: flex;
					align-items: end;
				}
			}

			.input_box{
				margin-top: 10px;
			}
		}
	}
</style>
<style>
	/*red border color*/
	.el-input__inner:focus,
	.el-select .el-input.is-focus .el-input__inner,
	.el-select .el-input__inner:focus,
	.el-radio__input.is-checked .el-radio__inner,
	.el-radio__inner:hover {
		border-color: var(--red);
	}

	/*red color*/
	.el-select-dropdown__item.selected,
	.el-radio__input.is-checked+.el-radio__label {
		color: var(--red);
	}

	/*red background color*/
	.el-radio__input.is-checked .el-radio__inner {
		background-color: var(--red);
	}
</style>
